import script from "./Browser.vue?vue&type=script&setup=true&lang=js"
export * from "./Browser.vue?vue&type=script&setup=true&lang=js"

import "./Browser.vue?vue&type=style&index=0&id=85b8ed22&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85b8ed22"]])

export default __exports__